import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "antd";
import "./Navbar.css";

export default function Navbar() {
  const [token, setToken] = useState(null);
  const [admin, setAdmin] = useState(false);
  const [width, setWidth] = useState(window.innerWidth - 200);

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  useEffect(() => {
    if (localStorage.getItem("doctor")) {
      const doctorStr = localStorage.getItem("doctor");
      const doctor = JSON.parse(doctorStr);
      if (doctor.email == "bharatrai2016@gmail.com") {
        setAdmin(true);
      }
    } else {
    }
    const token = localStorage.getItem("token");
    if (token) {
      setToken(token);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth - 200);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  {
    return (
      <div className="container">
        <div className="navbar">
          <Link to="/assessment-history">
            <img
              src={process.env.PUBLIC_URL + "/Assets/ethoslogo.png"}
              alt="Logo"
              className="h-[40px]"
            />
          </Link>
          <div
            className="nav-links"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              width: width,
            }}
          >
            <div>
              {token && (
                <>
                  <Link to="/assessment-history">Patient Dashboard</Link>
                  {admin && <Link to="/assessment-page">Assessment</Link>}
                </>
              )}
            </div>

            <div>
              {token && (
                <Button
                  onClick={handleLogout}
                  type="primary"
                  className="logout-button"
                >
                  Logout
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
